import { ArrowRight } from "lucide-react";
import { openModal } from "./data";
import { Eyebrow, Magnetic, MaskLines, Reveal } from "./ui-bits";

export const ForLandlords = () => (
  <section
    id="landlords"
    className="bg-ivory text-obsidian"
    data-testid="landlords-section"
  >
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <Eyebrow tone="dark">For Landlords</Eyebrow>
      <div className="mt-6 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <h2 className="font-serif text-4xl leading-[1.02] sm:text-5xl lg:text-6xl">
            <MaskLines
              lines={["YOUR PROPERTY", "DESERVES THE RIGHT", "OCCUPIER."]}
            />
          </h2>
          <Reveal delay={0.25}>
            <div className="mt-10">
              <Magnetic>
                <button
                  type="button"
                  onClick={() => openModal("list")}
                  className="group inline-flex items-center gap-3 bg-obsidian px-7 py-4 text-[12px] font-medium uppercase tracking-[0.22em] text-ivory transition-colors duration-500 hover:bg-champagne hover:text-obsidian"
                  data-testid="landlords-list-property-btn"
                >
                  List Your Property
                  <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
                </button>
              </Magnetic>
            </div>
          </Reveal>
        </div>
        <div className="grid content-center gap-10 sm:grid-cols-3 lg:col-span-6 lg:gap-6">
          {[
            ["Position", "Position your property for the right market."],
            ["Connect", "Reach relevant, credible occupiers."],
            ["Close", "Structure and negotiate deals that work."],
          ].map(([t, c], i) => (
            <Reveal key={t} delay={i * 0.1}>
              <div className="border-t border-obsidian/20 pt-5" data-testid={`landlords-pillar-${t.toLowerCase()}`}>
                <span className="font-serif text-sm italic text-champagne">
                  0{i + 1}
                </span>
                <h3 className="mt-3 font-serif text-2xl uppercase">{t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-obsidian/65">{c}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export const ForOccupiers = () => (
  <section
    id="occupiers"
    className="relative overflow-hidden bg-obsidian"
    data-testid="occupiers-section"
  >
    <img
      src="/assets/logo-light.png"
      alt=""
      aria-hidden
      className="pointer-events-none absolute -right-20 top-1/2 w-[420px] -translate-y-1/2 opacity-[0.05]"
    />
    <div className="relative mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <Eyebrow tone="champagne">For Occupiers</Eyebrow>
      <h2 className="mt-6 font-serif text-4xl leading-[1.02] text-ivory sm:text-5xl lg:text-6xl">
        <MaskLines
          lines={["YOUR BUSINESS", "DESERVES THE RIGHT", "ADDRESS."]}
        />
      </h2>

      <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {[
          ["Understand", "Your business requirement."],
          ["Identify", "The right micro-markets."],
          ["Evaluate", "Real commercial potential."],
          ["Secure", "The right deal."],
        ].map(([t, c], i) => (
          <Reveal key={t} delay={i * 0.1}>
            <div className="border-t border-ivory/15 pt-5" data-testid={`occupiers-step-${t.toLowerCase()}`}>
              <span className="font-serif text-sm italic text-champagne">
                0{i + 1}
              </span>
              <h3 className="mt-3 font-serif text-2xl uppercase text-ivory">{t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone">{c}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-14">
          <Magnetic>
            <button
              type="button"
              onClick={() => openModal("find")}
              className="group inline-flex items-center gap-3 bg-ivory px-7 py-4 text-[12px] font-medium uppercase tracking-[0.22em] text-obsidian transition-colors duration-500 hover:bg-champagne"
              data-testid="occupiers-find-space-btn"
            >
              Find a Space
              <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
            </button>
          </Magnetic>
        </div>
      </Reveal>
    </div>
  </section>
);
